<template lang="pug">
  div
    div(v-if="loaded && despacho !== null && active === 0")
        analisar-validar-processo-ba(
          :responseAnalise="responseAnalise",
          :processo="processo",
          :idProcesso="idProcesso",
          :acaoCaixa="acaoCaixa",
          :regras="regras",
          ref="formularioCertidaoArea"
          )
    div.analise(v-if="despacho !== null && active === 1")
      app-analise-header(
        :id-processo="despacho.processo.id",
        v-if="despacho.processo !== null"
        :numero-processo="despacho.processo.numeroProcesso",
        :statusProcesso="despacho.processo.status"
        titulo-analise="Emissão de Certidão de Área"
        :tipo="typeof despacho.processo.tipo === 'object' ? despacho.processo.tipo.codigo : despacho.processo.tipo",
        :numeroProtocolo="despacho.processo.numeroProtocolo",
        :show-separate="true"
        :show-messages='true',
        :opcoesHeader="true",
        :btnSolicitarInformacao="true",
        :idDespacho="despacho.id",
      )
        template(slot="separate")
          el-card(shadow="hover").card-collapse
            app-despachos(
              :idProcesso="idProcesso",
              :data="dadosCadastro",
              @getDownload="getDownload",
              v-if="dadosCadastro"
            )
        template(slot="analise")
          el-steps.extra-margin-top-bottom(:active='active', finish-status='success', simple)
            el-step(title='Informar dados')
            el-step(title='Confirmar dados')
          div
            el-card(shadow="hover").card-collapse
              app-formulario-certidao-area(
                :despacho="responseAnalise.despacho"
                ref='formulario'
                v-if="despacho"
              )
    div(v-if="active === 2 && despacho !== null")
      app-pdf-viewer(
        v-if="bytes"
        :bytes = "bytes"
      )
      el-row(v-if="despacho.acao === 'RETORNO.SISTEMA.ANTERIOR'")
        validation-provider( rules="required", v-slot="{ errors }")
          app-label.input-text-editor(label="Despacho")
          app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="despacho.textoDespacho",
            :class="{'erro' : errors.length}"
            ref="editorTexto"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
        app-anexo(
          :id="'upload-anexo-despacho'",
          @uploadFile="uploadFile",
          :files="despacho.documentos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
          :tipoExibir="'ANEXO_ANALISE'"
        )
      validation-observer.flex-around(ref='validationTitulo' tag='div')
        app-radios-tramitacao(
          :radios="acoesRadio",
          :isDecisao="false",
          @changeRadio="changeRadio",
          :radioInicial="despacho.acao",
        )
    app-buttons-cadastro(
      :isUltimoPasso="active === 2",
      :isPrimeiroPasso="active === 0",
      :showButtonSalvar="[0,1].includes(active)",
      :showButtonDownload="[2].includes(active)",
      :showButtonCancelar="[0].includes(active)",
      :showButtonFinalizar="[2].includes(active)"
      :showButtonProximo="[0,1].includes(active)"
      @proximo="proximo",
      @finalizar="finalizar",
      @cancelar="cancelar",
      @salvar="salvarCertidaoArea",
      @download="downloadPdf",
      @voltar="voltar"
    )
</template>
<script>
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import FileHelper from '@/utils/fileHelper'
import { mapActions, mapGetters } from 'vuex'
import AppDespachos from '@/components/AppDespachos'
import AppAnaliseHeader from './components/shared/AppAnaliseHeader'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDivider from '@/components/AppDivider'
import AppFormularioCertidaoArea from './components/AppFormularioCertidaoArea.vue'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import AppPdfViewer from '@/components/AppPDFViewer'
import acaoProcesso from '@/constants/acaoProcesso'
import AppLabel from '@/components/AppLabel'
import AnalisarValidarProcessoBa from './AnalisarValidarProcessoBa.vue'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { exibirBotoesDecisao, statusBotoesDecisao } = regrasAnalise.cadastro
const { messages } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

export default {
  components: {
    AppDespachos,
    AppButtonsCadastro,
    AppRadiosTramitacao,
    AppDivider,
    AppFormularioCertidaoArea,
    AppPdfViewer,
    AppAnaliseHeader,
    AppLabel,
    AppEditorTexto,
    AppAnexo,
    AnalisarValidarProcessoBa
  },

  mixins: [AppNotificacao],

  props: {
    idProcesso: {
      required: true
    },
    acaoCaixa: {
      type: String,
      default: acaoProcesso.ANALISAR
    },
    tipo: {
      type: String,
      default: acaoProcesso.EMITIR_CERTIDAO_AREA
    },
    urlOrigem: {
      type: String,
      default: 'CAIXA_ENTRADA'
    }
  },

  data () {
    return {
      active: 0,
      bytes: null,
      despacho: null,
      dadosCadastro: null,
      acoesRadio: [],
      processo: null,
      loaded: false,
      responseAnalise: null
    }
  },

  async mounted () {
    await this.iniciaEmissao()
  },

  methods: {
    ...mapActions({
      iniciaAnalise: 'processo/iniciaAnalise',
      getProcessoById: 'processo/getProcessoById',
      salvar: 'despacho/salvar',
      finalizarDespacho: 'despacho/finalizar',
      tarefa: 'processo/tarefa',
      getArrayCertidaoArea: 'despacho/getArrayCertidaoAreaByDespachoId'
    }),

    async salvarCertidaoArea () {
      if (this.active === 0) {
        await this.$refs.formularioCertidaoArea.salvar()
        return
      }
      var despacho = await this.$refs.formulario.save()
      try {
        await this.salvar(despacho)
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          `${messages.headerCertidaoArea} salvo com Sucesso.`)
      } catch (e) {}
    },

    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),

    cancelar () {
      this.confirmBox(
        `Ao cancelar a Emissão da Certidão de Área, ${this.$messages.CANCELAR_EMISSAO_TITULO_CERTIDAO}`,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => {}
      )
    },

    getMensagemEncaminhamento () {
      switch (this.despacho.acao) {
        case 'FINALIZAR.NDI':
          return 'Processo encaminhado para NOT'
        case 'RETORNO.SISTEMA.ANTERIOR':
          return 'Processo retornou para Análise Documental, NDI'
        default:
          return ''
      }
    },

    async finalizar () {
      if (this.despacho.acao) {
        if (this.despacho.acao === 'RETORNO.SISTEMA.ANTERIOR' && !this.despacho.textoDespacho) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Preencha o campo despacho antes de encaminhar o processo.'
          )
          return
        }
        if (!this.despacho.numeroSei) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Preencha o campo numero Sei antes de encaminhar o processo.'
          )
          return
        }
        this.confirmBox(
          this.$messages.MSG_CONFIRMACAO,
          this.$messages.TITULO_WARNING,
          () => {
            this.finalizarDespacho(this.responseAnalise.despacho)
              .then(() => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  this.getMensagemEncaminhamento()
                )
                this.$router.push({
                  name: this.urlOrigem
                })
              })
              .catch(error => {
                const erroValidacao = error.status === 422
                const tipoErro = !erroValidacao
                  ? this.$messages.TIPO_ERROR
                  : this.$messages.TIPO_WARNING
                const tituloErro = !erroValidacao
                  ? this.$messages.TITULO_ERROR
                  : this.$messages.TITULO_WARNING
                const messagemDeErro =
                  Array.isArray(error.erros) && erroValidacao
                    ? error.erros.join(';')
                    : 'Erro ao emitir/conferir certidão de área.'
                this.showNotificacao(tipoErro, tituloErro, messagemDeErro)
              })
          },
          () => {}
        )
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Selecione para onde deseja encaminhar o processo.'
        )
      }
    },

    async iniciaEmissao () {
      const response = await this.iniciaAnalise({
        idProcesso: this.idProcesso,
        tipoAcao: this.acaoCaixa
      })
      this.processo = await this.getProcessoById(this.idProcesso)
      this.responseAnalise = response
      this.setDespachoVazio(response)
      this.dadosCadastro = response.setores
      if (this.responseAnalise) {
        this.loaded = true
      }
      const radios = await this.tarefa({ processo: this.idProcesso })
      this.acoesRadio = radios.acoes
    },

    async proximo () {
      if (this.active === 0) {
        if (!this.responseAnalise?.despacho?.numeroSei || !this.responseAnalise?.despacho?.textoDespacho) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Preencha todos os campos antes de encaminhar o processo.'
          )
          return
        } else {
          await this.$refs.formularioCertidaoArea.salvar()
          this.active++
          return
        }
      }
      this.despacho = await this.$refs.formulario.save()
      if (this.despacho) {
        const despachoSalvo = await this.salvar(this.despacho)
        const arraybufferCertidaoArea = await this.getArrayCertidaoArea(despachoSalvo.id)
        this.despacho.id = despachoSalvo.id
        this.bytes = arraybufferCertidaoArea
        this.active++
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Para finalizar a análise preencha todos os campos destacados.'
        )
      }
    },

    async voltar () {
      await this.iniciaEmissao()
      this.active--
    },

    downloadPdf () {
      FileHelper.saveFile(
        this.bytes,
        this.despacho.processo.tipo.codigo === 'minuta da certidão de área'
      )
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    changeRadio (value) {
      this.despacho.acao = value.acao
    },

    setDespachoVazio (response) {
      if (response.despacho.status !== 'FINALIZADO') {
        this.despacho = response.despacho
      } else {
        this.despacho = {
          ...response.despacho,
          textoDespacho: '',
          documentos: [],
          processo: response.despacho.processo,
          id: null,
          numeroDaCertidao: null,
          tituloDespacho: { tituloProcesso: null, tituloProcessoDTO: {} }
        }
      }
    },

    onTextChange (text) {
      this.despacho.textoDespacho = text
    },

    uploadFile (file) {
      this.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.id === documento.id)
        )
        this.despacho.documentos.splice(index, 1)
      } else {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.key === documento.key)
        )
        this.despacho.documentos.splice(index, 1)
      }
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    getAcaoAnalise () {
      return acaoProcesso.ANALISE
    },
    setActive (active) {
      this.active = active
    },
    showButtonsDecisao () {
      return exibirBotoesDecisao.setores.includes(this.usuario?.perfilSelecionado.setor.codigo) || (statusBotoesDecisao.status.includes(this.processo?.status) && statusBotoesDecisao.perfis.includes(this.usuario?.perfilSelecionado.codigo))
    }
  },
  computed: {

    regras () {
      return {
        showButtonsDecisao: this.showButtonsDecisao()
      }
    }

  }
}
</script>
<style lang="scss">
.padding {
  padding: 5px;
}

.required {
  color: firebrick;
}

.margin {
  margin-top: 10px;
  margin-bottom: 10px;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.container-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label {
  font-weight: bold;
}

.radios-despacho-parecer {
  display: flex;
  justify-content: center;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.extra-margin-top-bottom {
  margin-top: 30px;
  margin-bottom: 30px;
}

.margin-medium-top {
  margin-top: 20px;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.error {
  border: solid 1px firebrick;
  border-radius: 5px;
}

.tipo-de-analise {
  margin-bottom: 15px;
  span {
    font-weight: bold;
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/EmitirCertidaoArea.vue